exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.uhe-image[data-v-05a32cdd] {\n    width: 100%;\n    height: auto;\n}\n", ""]);

